goog.provide('el8.appchart.dialog.cqmDashboardDialog');

goog.require('el8.util.localStorage');
goog.require('el8.appchart.cqmRefresh');
goog.require('el8.model.identify');
goog.require('el8.service.tz');
goog.require('el8.template.appchart.dialog.cqmDashboardDialog');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.shared.util.cqm');

el8.appchart.dialog.cqmDashboardDialog = (function() {
    
    var that = new el8.uiwidget.NewDialog({
        title: 'CQM Debug Window',
        autoHeight: false,
        width: 650,
        height: 400,
        showXButton: true
    });

    var elts = {};

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.setContent(el8.template.appchart.dialog.cqmDashboardDialog.layout());

        elts.filter_field = $("#cqm-dashboard-measures-filter");
        elts.filter_field.keydown(_.debounce(function() {
            if (!el8.appchart.cqmRefresh.cqmStatus || !el8.appchart.cqmRefresh.cqmStatus.results) { return; }
            var query = this.value.toLowerCase();
            el8.util.localStorage.setItem('cqm_dashboard_measures_filter', this.value);

            _.map(el8.appchart.cqmRefresh.cqmStatus.results, function(results, measureId) {
                var container = $('#cqm-dashboard-measure-wrapper-' + measureId);
                if (query === "" || results['measure_code'].toLowerCase().indexOf(query) !== -1 || 
                    results['display_name'].toLowerCase().indexOf(query) !== -1) {
                    container.show();
                }
                else {
                    container.hide();
                }
            });
        }, 100));

        var filter_value = el8.util.localStorage.getItem('cqm_dashboard_measures_filter');
        if(filter_value) {
            elts.filter_field.val(filter_value).trigger('keydown');
        }

        elts.filter_field.focus();

        elts.year_field = $("#cqm-dashboard-measures-year").change(function() {
            el8.appchart.cqmRefresh.setReportingYear(this.value);
            el8.appchart.cqmRefresh.forceRefresh(true);
        });

        var year_selected = el8.appchart.cqmRefresh.getReportingYear();
        elts.year_field.val(year_selected);

        el8.appchart.cqmRefresh.forceRefresh(true);
    };

    el8.appchart.cqmRefresh.register({
        startCb: function() {
            $("#cqm-dashboard-refresh-status").show();
            $("#cqm-dashboard-refresh-status-error").hide();
        },
        updateCb: function(url, changed) {
            if (el8.appchart.cqmRefresh.cqmStatus.results) {
                $("#cqm-dashboard-calculator-output-link").attr('href', url);
                $("#cqm-dashboard-extractor-output-link").attr('href', '/quality_measures/' + el8Globals.PATIENT_ID + '/chart_data/');
                updateMeasuresList();
            }
        },
        endCb: function() {
            $("#cqm-dashboard-refresh-status").hide();
            $("#cqm-dashboard-refresh-status-error").hide();
        },

        errorCb: function() {
            $("#cqm-dashboard-refresh-status").hide();
            $("#cqm-dashboard-refresh-status-error").show();
        }
    });

    function updateMeasuresList() {
        var contentElt = $("#cqm-dashboard-measures-list");
        contentElt.empty();
        _.map(el8.appchart.cqmRefresh.cqmStatus.results, function(results, measureId) {
            var detailsContainerSelector = '#cqm-dashboard-measure-details-' + measureId;
            var container = $(detailsContainerSelector);
            if (container.length === 0) {
                contentElt.append(el8.template.appchart.dialog.cqmDashboardDialog.measureSection({
                    'results': results, 'id': measureId
                }));

                el8.uiwidget.collapsible({
                    container: $(detailsContainerSelector),
                    triggerElt: $('#cqm-dashboard-measure-header-' + measureId),
                    statusElt: $('#cqm-dashboard-measure-status-' + measureId),
                    expandFn: function() { 
                        fetchAndUpdateMeasureDetails(measureId);
                    },
                    isCollapsed: true,
                    consumeClick: false
                });
            }
            else {
                fetchAndUpdateMeasureDetails(measureId);
            }
        });

        var measureElts = contentElt.children();
        measureElts.sort(function (a, b) {
            var an = a.getAttribute('data-name'),bn = b.getAttribute('data-name');

            if(an > bn) {
                return 1;
            }
            if(an < bn) {
                return -1;
            }
            return 0;
        });
        measureElts.detach().appendTo(contentElt);

        if(elts.filter_field) {
            elts.filter_field.trigger('keydown');
        }
    }

    function fetchAndUpdateMeasureDetails(measureId) {
        var containerElt = $('#cqm-dashboard-measure-details-' + measureId);
        containerElt.html('<div class="el8Loading"></div>');
        el8.appchart.cqmRefresh.fetchMeasureGuidance(measureId).done(function(guidanceData) { 
            updateMeasureDetails(measureId, guidanceData.guidance);
        });
    }

    function updateMeasureDetails(measureId, guidance) {
        var now = el8.appchart.cqmRefresh.getReportingDate();

        var container = $('#cqm-dashboard-measure-details-' + measureId);
        container.empty();
        var measureResults = el8.appchart.cqmRefresh.cqmStatus.results[measureId];
        _.map(guidance, function(labelDetails) {
            var populationLabel = labelDetails['label'];
            var records = measureResults['timelapse_map'][populationLabel];
            var recordForCurrentDate = el8.shared.util.cqm.findRecord(records, now);

            var populationName = populationLabel.substring(1).replace('_', ' ');

            container.append(el8.template.appchart.dialog.cqmDashboardDialog.populationStatus({
                populationName: populationName, 
                status: recordForCurrentDate['result'],
                summary: labelDetails['summary']
            }));

            _.map(labelDetails['elements'], function(populationElement) {
                var linkifyResult = linkifyLabels(measureId, typeof(populationElement) === 'string'? populationElement : populationElement['summary']);
                var summary = linkifyResult[0];
                var labels = linkifyResult[1];
                var labelDisplayNames = linkifyResult[2];

                if (typeof(populationElement) !== 'string' && 'chosen_items_list' in populationElement) {
                    labels = [];
                    labelDisplayNames = [];
                    _.map(populationElement['chosen_items_list'], function(labelWithName) {
                        var linkifyResult = linkifyLabels(measureId, labelWithName);
                        labels.push.apply(labels, linkifyResult[1]);
                        labelDisplayNames.push.apply(labelDisplayNames, linkifyResult[2]);
                    });
                }

                var recordsAndDeadlines = _.map(labels, function(label) {
                    return label.startswith('~')? [null, null] : 
                        el8.shared.util.cqm.findRecordAndDeadline(measureResults['timelapse_map'][label], now);
                });
                var records = _.pluck(recordsAndDeadlines, 0);
                var deadlines = _.pluck(recordsAndDeadlines, 1);
                var indicatorRecords = records;

                if (typeof(populationElement) !== 'string' && 'indicator_label' in populationElement) {
                    var indicatorLabel = populationElement['indicator_label'];
                    indicatorRecords = [el8.shared.util.cqm.findRecord(measureResults['timelapse_map'][indicatorLabel], now)];
                }
            
                var nonSatisficingRecord = _.find(indicatorRecords, function(record) { 
                    return record !== null && (record['result'] === false || record['result'] === null); 
                });

                var elt = $(el8.template.appchart.dialog.cqmDashboardDialog.populationElement({
                    status: nonSatisficingRecord === undefined,
                    summary: summary
                }));
                container.append(elt);
                $('.cqm-details-label-link a', elt).click(showLabelCodes);

                _.each(_.zip(labelDisplayNames, records, deadlines), function(x) {
                    var name = x[0];
                    var record = x[1];
                    var deadline = x[2];

                    if (record !== null) {
                        var haveResult = record['result'] !== null;
                        var dueDates = el8.shared.util.cqm.calculateDueDates(deadline);

                        var deadlineString = haveResult ? 'Next ' + name : name;
                        var classification = el8.shared.util.cqm.classifyDueDates(dueDates, now);
                        switch (classification) {
                            case 'impossible':
                            case 'none':
                                deadlineString = null;
                                break;
                            case 'overdue':
                                deadlineString += ' overdue since ' + dueDates.dueEndDateStr;
                                break;
                            case 'interval':
                                deadlineString += ' due between ' + dueDates.dueStartDateStr + ' and ' + dueDates.dueEndDateStr;
                                break;
                            case 'ending':
                                deadlineString += ' due by ' + dueDates.dueEndDateStr;
                                break;
                            case 'starting':
                            case 'since':
                                deadlineString += ' due starting ' + dueDates.dueStartDateStr;
                                break;
                            default:
                                deadlineString = null;
                                UIM && UIM.logError('Unknown due date classification: ' + classification);
                                break;
                        }   

                        if (haveResult) {
                            container.append(el8.template.appchart.dialog.cqmDashboardDialog.matchedItem({
                                name: name,
                                item: stringifyItem(record['result'])
                            }));
                        }
                        if (deadlineString) {
                            container.append(el8.template.appchart.dialog.cqmDashboardDialog.itemDeadline({
                                currentlySatisfied: haveResult,
                                deadlineString: deadlineString
                            }));
                        }
                        if (record['remainder'] && record['remainder'].length > 0) {
                            var items = _.map(record['remainder'], stringifyItem);
                            container.append(el8.template.appchart.dialog.cqmDashboardDialog.unmatchedItems({
                                name: name,
                                items: items
                            }));
                        }
                    }
                    else {
                        container.append(el8.template.appchart.dialog.cqmDashboardDialog.itemDetailsUnavailable({
                            name: name
                        }));
                    }
                });
            });
        });
    }

    function stringifyItem(item) {
        var str = "";
        if (typeof item === "boolean") {
            str = item.toString();
        }
        else if ('source' in item) {
            var modelName = el8.model.idToModelClass(item['source']);
            str = "[" + modelName + "] id:" + item['source'];
        }
        else {
            str = "[(non-Entity object)]";
        }
        
        var attrs = _.map(item, function(value, key) {
            if (key === "start" || key === "end") {
                return key + ":" + el8.service.tz.asServerFormatDateTime(
                    new Date(Date.parse(value)));
            }
            else if (key === 'source') {
                return "";
            }
            else {
                return key + ":" + value;
            }
        });
        return str + " " + attrs.join(" ");
    }

    function linkifyLabels(measureId, text) {
        var parts = el8.shared.util.cqm.parseLabels(text);
        var result = [];
        var allLabels = [];
        var allLabelDisplayNames = [];
        for (var i = 0; i < parts.length; i += 2) {
            result.push(parts[i]);
            if (i === parts.length - 1) { break; }

            var labelInfo = parts[i + 1];
            allLabels.push(labelInfo.labels[0]); // Not supporting multiple labels with one replacement text at the moment
            allLabelDisplayNames.push(labelInfo.replacementText);

            var linkText = labelInfo.replacementText;
            if (i === 0 && parts[i] === '') {
                linkText = linkText.charAt(0).toUpperCase() + linkText.substr(1);
            }
            
            result.push('<span class="cqm-details-label-link" style="position:relative;""><a href="#" data-measure-label="' + measureId + '.' + labelInfo.labels[0] + '">' + linkText + '</a></span>');
        }

        return [result.join(''), allLabels, allLabelDisplayNames];
    }

    function showLabelCodes(event) {
        var targetElt = $(event.target);
        var measureAndLabel = targetElt.attr('data-measure-label');
        var measure = parseInt(measureAndLabel.split('.')[0], 10);
        var label = measureAndLabel.split('.')[1];
        if (label.startswith('~')) {
            label = label.substring(1);
        }
        el8.appchart.cqmRefresh.fetchMeasureGuidance(measure).done(function(guidanceData) {
            var popupElt = $("#cqm-details-label-link-popup");
            if (popupElt.length === 0 || popupElt.attr('data-measure-label') !== measureAndLabel) {
                popupElt.remove();
                popupElt = $('<div id="cqm-details-label-link-popup" data-measure-label="' + measureAndLabel + '" style="position:absolute; left:0px; bottom:100%; max-height:100px; min-width:200px; overflow-y:scroll; background-color:#fff; padding:6px; border:1px solid #000; border-radius:2px;"></div>');
                var codes = guidanceData.codes[label];
                _.map(codes, function(codeDict, context) {
                    var codeSystemSelectElt = $('<select class="ebs-isolate mb5"></select>');
                    popupElt.append(codeSystemSelectElt);
                    var codeListElts = [];
                    _.map(codeDict, function(codeList, codeSystem) {
                        var codeSystemName = guidanceData.code_system_names[codeSystem];
                        codeSystemSelectElt.append('<option>' + codeSystemName + ' (context: ' + context + ')</option>');
                        codeList.sort();
                        codeListElts.push($('<div>' + codeList.join(' ') + '</div>'));
                    });
                    _.each(codeListElts, function(elt) { popupElt.append(elt); });

                    function showCodeList(index) {
                        for (var i = 0; i < codeListElts.length; i++) {
                            if (i === index) { codeListElts[i].show(); } else { codeListElts[i].hide(); }
                        }
                    }
                    codeSystemSelectElt.change(function() {
                        showCodeList(this.selectedIndex);
                    });
                    showCodeList(0);
                });
                targetElt.parent().append(popupElt);
            }
            else {
                popupElt.remove();
            }
        });
    }

    return that;
})();

